'use client'

import * as React from 'react'

const ModalRootContext = React.createContext(true)
const ModalLayerContext = React.createContext(false)

interface ModalRootProviderProps {
  children: React.ReactNode
  modal?: boolean
}

function ModalRootProvider({
  children,
  modal = true,
}: ModalRootProviderProps) {
  return (
    <ModalRootContext.Provider value={modal}>
      {children}
    </ModalRootContext.Provider>
  )
}

interface ModalLayerProviderProps {
  children: React.ReactNode
}

function ModalLayerProvider({ children }: ModalLayerProviderProps) {
  const isModalRoot = React.useContext(ModalRootContext)

  return (
    <ModalLayerContext.Provider value={isModalRoot}>
      {children}
    </ModalLayerContext.Provider>
  )
}

function useModalLayer() {
  return React.useContext(ModalLayerContext)
}

export { ModalLayerProvider, ModalRootProvider, useModalLayer }
